module.exports = __webpack_public_path__ + "img/icon-projects.a095973b.svg";